<template>
  <div class="mobilePage">
    <div class="nav"
         :style="isSimple?'background: linear-gradient(270deg, rgb(255, 179, 87), rgb(222, 77, 53));}':'background: linear-gradient(270deg, rgb(46 82 210), rgb(24, 94, 211));'">
      <img class="imgtuzai"
           :src="logosrc"
           alt="">
      <!-- <img v-else
           class="imgyunzhi"
           src="@/assets/mobilePage/logo.png"
           alt=""> -->
      <div @click="showNavList=true"></div>
    </div>
    <div class="topHover">
      <div class="search">
        <div class="searchhd">
            <van-dropdown-menu active-color="#185ED3">
              <van-dropdown-item @change='dropdownchange' v-model="value1" :options="option1" />
            </van-dropdown-menu>
          <van-search v-model="searchContent"
                      @blur="onSearch"
                      show-action
                      right-icon="search"
                      left-icon=""
                      action-text="取消"
                      shape="round"
                      style="width:78%;"
                      placeholder="请输入关键字"
                      @cancel="onCancel" />
        </div>
        <!-- @search="onSearch" -->
        <div class="selectClass"
             v-if="!showCheckBox">
          <div class="chooseList">
            <div :class="choosePicAltasIndex==0?'active':''"
                 :style="(isSimple&&choosePicAltasIndex==0)?'background-color: #fd9112':''"
                 @click="choosePicAltasFun(0)">
              图片</div>
            <div :class="choosePicAltasIndex==1?'active':''"
                 :style="(isSimple&&choosePicAltasIndex==1)?'background-color: #fd9112':''"
                 @click="choosePicAltasFun(1)">
              图集</div>
            <!-- <div class="isBottom">{{isBottom}}</div>
            <div class="isBottom1">{{isLoading}}</div> -->
          </div>
          <div class="select"
               @click="showpopup=true">
            <div></div><span>筛选</span>
            <img src="@/assets/mobilePage/filtrate.png"
                 alt="">
          </div>
        </div>
        <div class="showCheckBox"
             v-else>
          <img @click="fanhuilist"
               src="@/assets/mobilePage/closeCheckBox.png"
               alt="">
          <span>已选择 {{checkCount}} 张</span>
          <img v-if="!checkAll"
               @click="checkAllImg(true)"
               src="@/assets/mobilePage/noCheck.png"
               alt="">
          <img v-else
               @click="checkAllImg(false)"
               src="@/assets/mobilePage/checkAllIcon.png"
               alt="">
        </div>
      </div>
      <div class="searchList"
           v-if="searchList.length > 0 && choosePicAltasIndex == 0">
        <span class="span"
              v-for="(item,index) in searchList"
              :key="index">
          {{item.name}}
          <img @click="deleteSearchCondition(item.id)"
               src="@/assets/mobilePage/close.png"
               alt="">
        </span>
      </div>
    </div>
    <div class="imgAll"
         v-if="choosePicAltasIndex==0 && imgList.length > 0">
      <div class="loading"
           v-if="imgLoading && choosePicAltasIndex==0">
        <!-- <van-loading></van-loading> -->
        <span>正在加载中...</span>
      </div>
      <div class="imgListWater">
        <div v-for="(item,index) in imgList"
             :class="showCheckBox?item.checkFalg?'imgItem checktrue':'imgItem checkfalse':'imgItem'"
             @click="clickImagePreview(item,index)"
             :style="'background: url('+item.src+') no-repeat'"
             :key="index">
          <div v-if="showCheckBox">
            <img v-if="item.checkFalg"
                 src="@/assets/mobilePage/checktrue.png"
                 alt="">
            <img v-else
                 src="@/assets/mobilePage/checkfalse.png"
                 alt="">
          </div>
          <!-- <img :src="item.src"
               alt=""> -->
        </div>
      </div>
      <!-- <div class="imgListleft">
        <div v-for="(item,index) in imgList"
             class="imgItem"
             @click="clickImagePreview(item,index)"
             :key="index">
          <img :src="item.src"
               alt="">
        </div>
      </div>
      <div class="imgListright">
        <div v-for="(item,index) in imgList1"
             class="imgItem"
             @click="clickImagePreview(item,index+1)"
             :key="index">
          <img :src="item.src"
               alt="">
        </div>
      </div> -->
    </div>
    <!-- {{altasList}}{{altasList1}} -->
    <div class="imgAll"
         v-if="choosePicAltasIndex==1 && altasList.length + altasList1.length > 0">
      <div class="loading"
           v-if="altasLoading && choosePicAltasIndex==1">
        <!-- <van-loading></van-loading> -->
        <span>正在加载中...</span>
      </div>
      <div class="imgListleft">
        <div v-for="(item,index) in altasList"
             class="imgItem"
             :key="index">
          <div class="imgClass"
               @click="clickltasPreview(item)"
               :style="'background: url('+ item.src+') no-repeat'">
            <div class="user"><img src="@/assets/mobilePage/usernameIcon.png"
                   alt="">{{item.createUserInfo.name.length>8?item.createUserInfo.name.substring(0,8) + '...':item.createUserInfo.name}}
            </div>
          </div>
          <!-- <img :src="item.src"
               @click="clickltasPreview(item)"
               alt=""> -->
          <div class="altasInfo">
            <div class="title"
                 @click.stop="showInfo(item.name)">
              {{item.name.length>16?item.name.substring(0,16) + '...': item.name}}</div>
            <div class="username">

              <span>{{item.createTime}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="imgListright">
        <div v-for="(item,index) in altasList1"
             class="imgItem"
             :key="index">
          <div class="imgClass"
               @click="clickltasPreview(item)"
               :style="'background: url('+ item.src+') no-repeat'">
            <div class="user"><img src="@/assets/mobilePage/usernameIcon.png"
                   alt="">{{item.createUserInfo.name.length>8?item.createUserInfo.name.substring(0,8) + '...':item.createUserInfo.name}}
            </div>
          </div>
          <!-- <img :src="item.src"
               @click="clickltasPreview(item)"
               alt=""> -->
          <div class="altasInfo">
            <div class="title"
                 @click.stop="showInfo(item.name)">
              {{item.name.length>16?item.name.substring(0,16) + '...': item.name}}</div>
            <div class="username">
              <span>{{item.createTime}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="(imgList.length == 0 &&choosePicAltasIndex==0 && imgLoading == false) || (altasList.length==0 && choosePicAltasIndex==1 && altasLoading == false)  "
         class="nonr">
      <img src="@/assets/piclist/nonr.png"
           alt="">
    </div>
    <div class="circle"
         v-if="!showCheckBox ">
      <!-- <div class="downloadIcon"
           @click="downloadImgFun">
        <img src="@/assets/mobilePage/downloadIcon.png"
             alt="">
      </div> -->
      <div class="uploadImg"
           @click="getMobileUpdateUrlAsync">
        <img src="@/assets/mobilePage/uploadIcon.png"
             alt="">
      </div>
      <div v-if="choosePicAltasIndex==0"
           @click="pushImgFun"
           class="pushImg">
        <img src="@/assets/mobilePage/pushIcon.png"
             alt="">
      </div>
    </div>
    <div class="downbtn"
         v-if="showCheckBox && !downloadFlag">
      <div class="shang">
        <div class="push"
           @click="pushUserFun(1)"><img src="@/assets/mobilePage/pushwork.png"
             alt=""> 推送至工作圈</div>
        <div class="upload"
            @click="pushUserFun(2)"><img src="@/assets/mobilePage/pushuser.png"
              alt=""> 推送至用户</div>
      </div>

      <div class="live"
           @click="pushUserFun(3)"><img src="@/assets/mobilePage/live.png"
             alt=""> 推送至图片直播</div>
    </div>

    <div class="downbtn"
         style="height:20vw"
         v-if="downloadFlag">
      <div class="live"
           @click="downloadPic"><img src="@/assets/piclist/downloadout.png"
             alt=""> 下载</div>
    </div>
    <van-popup v-model="showpopup"
               round
               class="vanpopup"
               position="bottom"
               :style="{ height: '85%' }">
      <div class="selectList">
        <div class="title">全部筛选</div>
        <!-- <div class="mineAltas"><span>个人图库</span>
          <van-switch size="20px"
                      v-model="mineAltasOpen" />
        </div> -->
        <div v-if="mineAltasOpen" class="mineAltas" style="margin-top:6vw"><span>状态</span>
          <!-- v-if="choosePicAltasIndex==1" -->
          <van-radio-group v-model="statusradio" direction="horizontal">
            <van-radio name="-1">全部</van-radio>
            <van-radio name="1">公开</van-radio>
            <van-radio name="0">私密</van-radio>
          </van-radio-group>
        </div>
        <p>所属图库</p>
        <div class="libList">
          <div @click="chooseLib(item)"
               :class="item.id == chooseLibIndex?'libItemActive libItem':'libItem'"
               v-for="(item,index) in libList"
               :style="(isSimple&&item.id == chooseLibIndex)?'background-color: #fd9112':''"
               :key="index">
            {{item.name}}
          </div>
        </div>

        <div v-if="choosePicAltasIndex==0 && !isSimple">
          <p>图片主题</p>
          <div class="libList">
            <div @click="choosePicTheme(item)"
                 :class="item.id == choosePicThemeIndex?'libItemActive libItem':'libItem'"
                 :style="(isSimple&&item.id == choosePicThemeIndex)?'background-color: #fd9112':''"
                 v-for="(item,index) in picTheme"
                 :key="index">
              {{item.name}}
            </div>
          </div>
          <p>所属环境</p>
          <div class="libList">
            <div @click="chooseEnvironment(item)"
                 :class="item.id == chooseEnvironmentIndex?'libItemActive libItem':'libItem'"
                 :style="(isSimple&&item.id == chooseEnvironmentIndex)?'background-color: #fd9112':''"
                 v-for="(item,index) in environmentList"
                 :key="index">
              {{item.name}}
            </div>
          </div>
        </div>
      </div>
      <div class="contributePeople">
        <div class="userList"
             v-if="showUserList">
          <div v-for="(item,index) in contributePeopleList"
               @click="clickUesrItem(item)"
               :key="index">{{item.text}}
          </div>
        </div>
        <div class="userList"
             v-if="showUserList1">
          <div v-for="(item,index) in contributePeopleList1"
               @click="clickUesrItem1(item)"
               :key="index">{{item.text}}
          </div>
        </div>
        <div class="inputBox1">
          <span>投稿人</span>
          <div class="inputBox">
            <input type="text"
                   v-model="inputValue"
                   @focus="listUserAsync();showUserList = true"
                   @blur="inputBlur"
                   @input="searchUser(inputValue)">
            <div class="clean"
                 @click="cleanInputValue"></div>
          </div>
        </div>
        <div class="inputBox1"
             v-if="!isSimple">
          <span>人物筛选</span>
          <div class="inputBox">
            <input type="text"
                   v-model="inputValue1"
                   @focus="listUserAsync1();showUserList1 = true"
                   @blur="inputBlur1">
            <div class="clean"
                 @click="cleanInputValue"></div>
          </div>
        </div>
      </div>
      <div class="storageTime">
        <span>入库时间</span>
        <div class="timeSection">
          <span @click="showStartTime=true;showEndTime=false;">{{startTimeText}}</span>
          <div></div>
          <span @click="showEndTime=true;showStartTime=false">{{endTimeText}}</span>
        </div>
      </div>
      <van-datetime-picker @confirm="confirmStartTime"
                           @cancel="showStartTime=false"
                           v-if="showStartTime"
                           v-model="storageStartTime"
                           :max-date="storageEndTime"
                           type="date"
                           title="开始时间" />
      <van-datetime-picker @confirm="confirmEndTime"
                           @cancel="showEndTime=false"
                           v-model="storageEndTime"
                           v-if="showEndTime"
                           :min-date="storageStartTime"
                           type="date"
                           title="结束时间" />
      <div class="lasthandle">
        <div class="reset"
             :style="isSimple?'background-color: #f5a950;':''"
             @click="resetInfo">重置</div>
        <div class="finish"
             :style="isSimple?'background-color: #fd9112;':''"
             @click="finish">完成</div>
      </div>
    </van-popup>

    <van-overlay :show="showNavList"
                 :lock-scroll='true'>
      <div class="overlay">
        <div class="closeimg"
             @click="showNavList=false">
          <img src="@/assets/mobilePage/indexclose.png"
               alt="">
        </div>
        <div class="searchItem">
          <!-- <div class="activeDiv">首页</div> -->
          <div class="font"
               @click="getMobileUpdateUrlAsync">上传图片</div>
          <div class="font"
               @click="searchClick">图片搜索</div>
          <!-- <div class="font">图片搜索</div> -->
        </div>

        <div class="login">
          <img class="headimg"
               src="@/assets/mobilePage/headPhoto.png"
               alt="">
          <p :style="isSimple?'background-color: #fd9112':''"
             @click="outLogin">退出登录</p>
        </div>
      </div>
    </van-overlay>
    <van-image-preview v-model="showImagePreview"
                       :startPosition="startImgCountIndex"
                       :showIndex="true"
                       @change="changeImagePreview"
                       :images="imgSrcList">
      <template v-slot:cover>
        <div class="description">
          <!-- <div class="title">{{imageTitle}}</div> -->
          <div class="desc">{{imageDesc}}</div>
        </div>
      </template>
    </van-image-preview>
    <van-image-preview v-model="showAltasPreview"
                       :showIndex="true"
                       :startPosition="startAltasImgCountIndex"
                       @close="closeAltasPreview"
                       @change="changeAltasImagePreview"
                       :images="altasSrcList">
      <template v-slot:cover>
        <div class="description">
          <div class="title">{{altasTitle}}</div>
          <div class="desc">{{altasImageDesc}}</div>
        </div>
      </template>
    </van-image-preview>
    <van-popup v-model="showpushwork"
               @close="closevanPopup">
      <div class="pushWork">
        <div class="title">{{vantPopInfo.title}}
          <van-icon @click="showpushwork=false"
                    size="24px"
                    name="cross" />
        </div>
        <input class="titleInput"
               type="text"
               v-model="pushUserTitle"
               placeholder="请输入标题">
        <!-- :filter-method="filterMethod" -->
        <el-select v-model="pushUserName"
                   filterable
                   @blur="inputBlur"
                   :placeholder="vantPopInfo.direction"
                   >
          <el-option v-for="item in contributePeopleList"
                     :key="item.value"
                     :label="item.text"
                     style="width:calc(100vw - 3vw);"
                     :value="item.value">
          </el-option>
        </el-select>
        <textarea class="textarea"
                  type="text"
                  maxlength="50"
                  placeholder="请输入备注,50字内"
                  v-model="pushUserTextarea"></textarea>
        <div class="btn">
          <div class="cancle"
               @click="showpushwork=false">取消</div>
          <div class="sure"
               @click="surePushUser">确定</div>
        </div>
      </div>
    </van-popup>
    
  </div>
</template>
<script> 
import { listPeople } from '@/api/people'

import { myActivityLive } from "@/api/activityLive";

import axios from 'axios'

import {
  mapGetters
} from "vuex";
import {
  powersObj
} from "@/constants/powers";
import {
  searchPicture,
  searchAtlas,
  advSearchPicture
} from "@/api/search";
import {
  picPrefix
} from "@/constants/piccommon";
import {
  errorPic
} from "@/plugins/errorPic";
import {
  listUser
} from "@/api/user";
import {
  listMyPowerLib
} from "@/api/lib";
import {
  Dialog,
  Toast
} from "vant"
import {
  getMobileUpdateUrl
} from "@/api/userCenter";
import {
  formatConversion
} from "@/plugins/getdate";
import {
  getAtlasSonIds
} from "@/api/atlas";
import {
  getPictures
} from "@/api/open";
import {
  Notify
} from 'vant';
import {
  listAtlasPictures,
  batchAddLog
} from "@/api/picture";
import {
  getAppBaseConfig
} from "@/api/config";
import {
  addPicturePackage
} from "@/api/picturePackage";
import {
  listWorkgroup
} from "@/api/workgroup";


export default {

  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      downloadFlag:false,

      contributeName1: '',
      inputValue1: '',
      startAltasImgCountIndex: 0,
      picPrefix,
      //权限
      powersObj,
      searchContent: '',
      searchList: [],
      imgList: [],
      imgList1: [],
      imgSrcList: [],
      altasList: [],
      altasList1: [],
      showpopup: false,
      libList: [],
      // picTheme: ['不限', '风景', '运动员', '环境', '劳作', '亲子活动', '开会', '抗洪抢险', '剪裁'],
      picTheme: [{
        id: 0,
        name: "不限",
      },
      {
        id: "风景",
        name: "风景",
      },
      {
        id: "运动员",
        name: "运动员",
      },
      {
        id: "环境",
        name: "环境",
      },
      {
        id: "劳作",
        name: "劳作",
      },
      {
        id: "亲子活动",
        name: "亲子活动",
      },
      {
        id: "开会",
        name: "开会",
      },
      {
        id: "抗洪抢险",
        name: "抗洪抢险",
      },
      {
        id: "剪裁",
        name: "剪裁",
      }
      ],
      environmentList: [{
        id: 0,
        name: "不限",
      },
      {
        id: "会场",
        name: "会场",
      },
      {
        id: "农田",
        name: "农田",
      },
      {
        id: "办公室",
        name: "办公室",
      },
      {
        id: "医院",
        name: "医院",
      },
      {
        id: "商超",
        name: "商超",
      },
      {
        id: "城市",
        name: "城市",
      },
      {
        id: "山川",
        name: "山川",
      },
      {
        id: "工厂",
        name: "工厂",
      },
      {
        id: "星空",
        name: "星空",
      },
      {
        id: "校园",
        name: "校园",
      },
      {
        id: "水源",
        name: "水源",
      },
      {
        id: "街道",
        name: "街道",
      },
      ],
      contributePeopleList: [],
      contributePeopleList1: [],
      vandropdown: '',
      peopleSearchValue: '',
      storageStartTime: new Date(),
      storageEndTime: new Date(),
      statusradio:'1',
      showStartTime: false,
      showEndTime: false,
      showNavList: false,
      imgLoading: false,
      altasLoading: false,

      chooseLibIndex: 0,
      chooseLibName: 0,
      choosePicThemeIndex: 0,
      chooseEnvironmentIndex: 0,
      choosePicAltasIndex: 0,
      contributeName: 0,
      startTime: '',
      endTime: '',
      startTimeText: '开始时间',
      endTimeText: '结束时间',

      showNavList: false,
      showImagePreview: false,
      imgIndex: 0,
      showAltasPreview: false,
      altasIndex: 0,
      altasSrcList: [],
      altasImageListInfo: [],

      loadimgListFlag: true,

      imgPage: 0,
      imgPageSize: 30,
      altasPage: 0,
      altasPageSize: 20,

      // imageTitle: '',
      imageDesc: '',
      altasTitle: '',
      altasImageDesc: '',

      imgPaginationTotal: 0,
      altasPaginationTotal: 0,
      imgCountIndex: 0,
      startImgCountIndex: 0,
      imgdesc: [],
      maxDate: new Date(),
      inputValue: '',
      showUserList: false,
      showUserList1: false,
      altasImgCount: 0,
      altasImgData: [],
      altasImgPage: 0,
      altasImgPageSize: 10,
      altasId: '',
      labels: [],
      logosrc: '',
      // isBottom: 0,
      // isLoading: false,
      nowAltasInfo: '',
      showCheckBox: false,
      showpushwork: false,
      pushUserTitle: '',
      pushUserName: '',
      pushUserTextarea: '',
      workList: '',
      vantPopInfo: {
        title: '推送用户',
        direction: '请选择用户',
        id: 1
      },
      mineAltasOpen: false,
      checkCount: 0,
      checkAll: false,

      value1: 0,
      option1: [
        { text: '全部', value: 0 },
        { text: '个人', value: 1 }
      ],
    }
  },
  watch: {
    inputValue1 (a) {
      this.listUserAsync1(a)
    }
  },
  methods: {

    dropdownchange(){
      if(this.value1 == 1){
        this.mineAltasOpen = true
      }else{
        this.mineAltasOpen = false
      }

      this.finish()
    },

    fanhuilist(){
      this.showCheckBox=false
      this.downloadFlag=false
    },
    
    async batchAddLogAsync (val) {
      let {
        status,
        data,
        message,
        errors
      } = await batchAddLog(val);
      if (status) {
        Notify({
          type: 'success',
          message: '正在依次下载图片！'
        })

        this.downloadFlag = false
        this.showCheckBox = false
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        // this.$message.error({ message: message + errortext });
        Notify({
          type: 'danger',
          message: {
            message: message + errortext
          }
        })
      }
    },
    downloadPic(){
      let pictureIds = []
      for (let i = 0; i < this.imgList.length; i++) {
        if (this.imgList[i].checkFalg) {
          pictureIds.push(this.imgList[i])
        }
      }

      // const image = new Image();
      // // 解决跨域 canvas 污染问题
      // image.setAttribute("crossOrigin", "anonymous");
      // image.onload = function() {
      //   const canvas = document.createElement("canvas");
      //   canvas.width = image.width;
      //   canvas.height = image.height;
      //   const context = canvas.getContext("2d");
      //   context.drawImage(image, 0, 0, image.width, image.height);
      //   //得到图片的base64编码数据
      //   const url = canvas.toDataURL("image/png");
      //   // 生成一个 a 标签
      //   const a = document.createElement("a");
      //   // 创建一个点击事件
      //   const event = new MouseEvent("click");
      //   // 将 a 的 download 属性设置为我们想要下载的图片的名称，若 name 不存在则使用'图片'作为默认名称
      //   a.download = name || "图片";
      //   // 将生成的 URL 设置为 a.href 属性
      //   a.href = url;
      //   // 触发 a 的点击事件
      //   a.dispatchEvent(event);
      //   // return a;
      // };
      // image.src = picPrefix + pictureIds[0].savepath;


      
      // for (let i = 0; i < pictureIds.length; i++) {
        // let Url = picPrefix + pictureIds[0].savepath
        // console.log(Url);

        // var blob=new Blob([Url], {type:'application/octet-stream'});
        // var url = URL.createObjectURL(blob);
        // var a = document.createElement('a');
        // a.href = url;
        // a.download = url.replace(/(.*\/)*([^.]+.*)/ig,"$2").split("?")[0];
        // var e = document.createEvent('MouseEvents');
        // e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        // a.dispatchEvent(e);
        // URL.revokeObjectURL(url);
        
      // }
      

      // var src = 'http://imtt.dd.qq.com/16891/26747DD8B125A8479AD0C9D22CA47BC9.apk?fsname=com.snda.wifilocating_4.2.91_3211.apk&csr=1bbd';
      // var form = document.createElement('form');
      // form.action = Url;
      // document.getElementsByTagName('body')[0].appendChild(form);
      // form.submit();

      // var src = 'http://imtt.dd.qq.com/16891/26747DD8B125A8479AD0C9D22CA47BC9.apk?fsname=com.snda.wifilocating_4.2.91_3211.apk&csr=1bbd';
      // var iframe = document.createElement('iframe');
      // iframe.style.display = 'none';
      // iframe.Url = "javascript: '<script>location.href=\"" + Url + "\"<\/script>'";
      // document.getElementsByTagName('body')[0].appendChild(iframe);





      // let link = document.createElement('a')
      //     // 这里是将url转成blob地址，
      //     axios(Url).then(res => {
      //       const blob = new Blob([res.data])
      //       link.href = URL.createObjectURL(blob)
      //       let temp = Url.split("?");
      //       temp = temp[0].split("/");
      //       let name = temp[temp.length - 1];//获得图片名字
      //       link.download = name;
      //       document.body.appendChild(link);
      //       link.click()
      //     })

      // var blob=new Blob([''], {type:'application/octet-stream'});
      // var url = URL.createObjectURL(blob);
      // var a = document.createElement('a');
      // a.href = Url;
      // a.download = Url.replace(/(.*\/)*([^.]+.*)/ig,"$2").split("?")[0];
      // var e = document.createEvent('MouseEvents');
      // e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      // a.dispatchEvent(e);
      // URL.revokeObjectURL(url);

      // if(pictureIds.length <= 0){
      //   Notify({
      //     type: 'danger',
      //     message: '请选择图片！'
      //   })

      //   return false;
      // }else{
      //   let postneed = []
      //   for (let i = 0; i < pictureIds.length; i++) {
      //     postneed.push({
      //       action:'download',
      //       resourceId:pictureIds[i].resourceId,
      //       resourceType:'picture',
      //       data:"{\"origin\":\"mobile\"}",
      //       targetUid:0
      //     })
      //   }

      //   this.batchAddLogAsync(postneed)
      // }

      // for (let i = 0; i < pictureIds.length; i++) {
        // var xhr = new XMLHttpRequest();
        // xhr.open('GET', picPrefix + pictureIds[0].savepath, true);
        // xhr.responseType = 'blob';    // 返回类型blob
        // let self = this
        // xhr.onload = function () {
        //   if (xhr.status === 200) {
        //       let blob = this.response;
        //       // 转换一个blob链接
        //       let u = window.URL.createObjectURL(new Blob([blob]))
        //       let a = document.createElement('a');
        //       a.download = `${pictureIds[0].desc ? pictureIds[0].desc : '图片下载'}.jpg`;
        //       a.href = u;
        //       a.style.display = 'none'
        //       document.body.appendChild(a)
        //       a.click();
        //       a.remove();
        //       window.URL.revokeObjectURL(u);
        //   }
        // };
        // xhr.send()
        
      // }
    },









    searchClick () {
      this.showNavList = false
      this.showpopup = true
    },
    checkAllImg (flag) {
      this.checkAll = flag
      if (flag) {
        for (let i = 0; i < this.imgList.length; i++) {
          this.imgList[i].checkFalg = true
        }
        this.checkCount = this.imgList.length
      } else {
        for (let i = 0; i < this.imgList.length; i++) {
          this.imgList[i].checkFalg = false
        }
        this.checkCount = 0
      }
    },
    closevanPopup () {
      this.pushUserName = ''
    },
    filterMethod (value) {
      // if (this.vantPopInfo.id == 1) {
      //   this.listUserAsync()
      // } else {

      // let val = {
      //   keyword: value
      // }
      // this.listWorkgroupAsync(val)
      // }
    },
    //获取工作圈列表
    async listWorkgroupAsync (val) {
      let {
        status,
        data,
        message,
        errors
      } = await listWorkgroup(val);
      if (status) {
        this.contributePeopleList = []
        for (let i = 0; i < data.length; i++) {
          this.contributePeopleList.push({
            value: data[i].id,
            text: data[i].name,
          });
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        // this.$message.error({ message: message + errortext });
        Notify({
          type: 'danger',
          message: {
            message: message + errortext
          }
        })
      }
    },
    surePushUser () {
      if (this.pushUserTitle.trim() == '') {
        Notify('请填写标题！')
        return
      }
      if (this.pushUserName == '') {
        if (this.vantPopInfo.id == 1) {
          Notify('请选择用户！')
        } else if (this.vantPopInfo.id == 2) {
          Notify('请选择工作圈！')
        } else if (this.vantPopInfo.id == 3) {
          Notify('请选择直播！')
        }
        return
      }
      // console.log(this.imgList);
      let pictureIds = []
      for (let i = 0; i < this.imgList.length; i++) {
        if (this.imgList[i].checkFalg) {
          pictureIds.push(this.imgList[i].resourceId)
        }
      }
      // console.log(this.pushUserName);
      // return false;
      let val
      if (this.vantPopInfo.id == 1) {
        val = {
          createUid: this.createUid,
          packageType: "push",
          pictureCount: pictureIds.length,
          pictureIds: pictureIds.join(','),
          targetUid: this.pushUserName,
          title: this.pushUserTitle,
          pushConfig: JSON.stringify({
            pushChannelId: 0,
            note: this.pushUserTextarea,
          }),
        };
      } else if (this.vantPopInfo.id == 2) {
        val = {
          createUid: this.createUid,
          packageType: "share",
          pictureCount: pictureIds.length,
          pictureIds: pictureIds.join(','),
          targetUid: 0,
          title: this.pushUserTitle,
          pushConfig: JSON.stringify({
            pushChannelId: 0,
            note: this.pushUserTextarea,
          }),
          targetWorkgroupId: this.pushUserName,
        }
      } else if (this.vantPopInfo.id == 3) {
        val = {
          createUid: this.createUid,
          packageType: "push",
          pictureCount: pictureIds.length,
          pictureIds: pictureIds.join(','),
          targetUid: 0,
          title: this.pushUserTitle,
          pushConfig: JSON.stringify({
            pushChannelId: 'live',
            activityLiveId:this.pushUserName,
            note: this.pushUserTextarea,
          })
        }
      }
      // console.log(val);
      // return
      this.addPicturePackageAsync(val);
    },
    async addPicturePackageAsync (val) {
      let {
        status,
        data,
        message,
        errors
      } = await addPicturePackage(val);
      if (status) {
        // this.$message.success("创建成功！");
        Notify({
          type: 'success',
          message: '创建成功！'
        })
        for (let i = 0; i < this.imgList.length; i++) {
          this.imgList[i].checkFalg = false
        }
        this.pushUserTitle = ''
        this.pushUserTextarea = ''
      } else {
        let errortext = "";
        for (const key in errors) {
          errortext += errors[key];
        }
        // this.$message.error({ message: message + errortext });
        Notify({
          type: 'danger',
          message: {
            message: message + errortext
          }
        })
      }
      this.showCheckBox = false
      this.showpushwork = false
    },
    pushUserFun (flag) {
      let falg = true
      for (let i = 0; i < this.imgList.length; i++) {
        console.log(i);
        if (this.imgList[i].checkFalg) {
          falg = false
          break
        }
      }
      if (falg) {
        Notify('请选择图片！')
        return
      }
      // if (this.vantPopInfo.title.trim() == '') {
      //   Notify('请填写标题！')
      //   return
      // }

      // if(this.vantPopInfo.direction.trim() == '') {
      //   Notify('请选择图片！')
      //   return
      // }
      if (flag == 1) {
        this.vantPopInfo.title = '推送至工作圈'
        this.vantPopInfo.direction = '请选择工作圈'
        this.vantPopInfo.id = 2
        this.listWorkgroupAsync()
      } else if (flag == 2){
        this.vantPopInfo.title = '推送至用户'
        this.vantPopInfo.direction = '请选择用户'
        this.vantPopInfo.id = 1
        this.listUserAsync()
      } else if (flag == 3){
        this.vantPopInfo.title = '推送至图片直播'
        this.vantPopInfo.direction = '请选择直播'
        this.vantPopInfo.id = 3
        this.myActivityLiveAsync()
      }
      this.showpushwork = true
    },
    pushImgFun () {
      this.showCheckBox = true
    },
    downloadImgFun () {
      this.showCheckBox = true
      this.downloadFlag = true

    },
    seeAltasImg (item, index) {
      console.log(item, index);
      this.nowAltasInfo = item
      this.altasSrcList = []
      for (let i = 0; i < item.srcList.length; i++) {
        this.altasSrcList.push(item.srcList[i].src)
      }
      this.startAltasImgCountIndex = index
      this.altasTitle = item.name
      this.altasImageDesc = item.srcList[index].desc
      this.showAltasPreview = true
    },
    showInfo (message) {
      Toast(message)
    },
    deleteSearchCondition (id) {
      this.imgList = []
      this.imgList1 = []
      let val = {}
      this.labels = []
      this.imgPage = 0

      if(!this.mineAltasOpen){
        this.statusradio = '1'
      }


      if (id == 0) {
        this.chooseLibIndex = this.libList[0].id
        this.searchList.shift()
        this.searchList.forEach(item => {
          this.labels.push(item.name)
        })
        val = {
          createUid: this.contributeName,
          labels: this.labels.join(','),
          page: this.imgPage,
          pageSize: this.imgPageSize,
          keyword: this.searchContent,
          timeStart: this.startTimeText == "开始时间" ? null : this.startTime,
          timeEnd: this.endTimeText == "结束时间" ? null : this.endTime,
          status: this.statusradio
        }
      } else if (id == 1) {
        this.choosePicThemeIndex = '0'
        if (this.searchList[0].id == 0) {
          this.searchList.splice(1, 1)
        } else {
          this.searchList.shift()
        }
        this.searchList.forEach(item => {
          if (item.id == 2) {
            this.labels.push(item.name)
          }
        });
        val = {
          createUid: this.contributeName,
          labels: this.labels.join(','),
          libId: this.chooseLibIndex == '0' ? null : this.chooseLibIndex,
          page: this.imgPage,
          pageSize: this.imgPageSize,
          keyword: this.searchContent,
          timeStart: this.startTimeText == "开始时间" ? null : this.startTime,
          timeEnd: this.endTimeText == "结束时间" ? null : this.endTime,
          status: this.statusradio
        }
      } else {
        this.chooseEnvironmentIndex = 0
        this.searchList.pop()
        this.searchList.forEach(item => {
          if (item.id == 1) {
            this.labels.push(item.name)
          }
        });
        val = {
          createUid: this.contributeName,
          labels: this.labels.join(','),
          libId: this.chooseLibIndex == '0' ? null : this.chooseLibIndex,
          page: this.imgPage,
          pageSize: this.imgPageSize,
          keyword: this.searchContent,
          timeStart: this.startTimeText == "开始时间" ? null : this.startTime,
          timeEnd: this.endTimeText == "结束时间" ? null : this.endTime,
          status: this.statusradio
        }
      }
      this.searchPictureAsync(val)
    },
    cleanInputValue () {
      this.inputValue = ''
      this.contributeName = null
      this.listUserAsync()
    },
    inputBlur () {
      setTimeout(() => {
        this.showUserList = false
      }, 50);
    },
    inputBlur1 () {
      setTimeout(() => {
        this.showUserList1 = false
      }, 50);
    },
    clickUesrItem (item) {
      console.log(item);
      this.contributeName = item.value;
      this.inputValue = item.text
    },
    clickUesrItem1 (item) {
      console.log(item.createUid);
      this.contributeName1 = item.createUid;
      this.inputValue1 = item.text
    },
    searchUser (val) {
      if (val != '') {
        console.log(val);
        this.listUserAsync(true)
      }
    },
    changeImagePreview (val) {
      // console.log(val);
      this.imageDesc = this.imgdesc[val]
      // console.log(this.imgList[val]);
      // if (this.imgList[val].desc) {
      //   this.imageDesc = this.imgList[val].desc
      // } else {
      //   this.imageDesc = ''
      // }
    },
    closeAltasPreview () {
      this.altasImgPage = 0
      // console.log(123);
    },
    async changeAltasImagePreview (val) {
      // console.log(val);
      // console.log(this.nowAltasInfo);
      // this.altasImageDesc = this.nowAltasInfo.srcList[val].desc
      if (val + 3 > this.altasImageListInfo.length && this.altasImageListInfo.length > 50 * (this.altasImgPage +
        1) - 1) {
        this.altasImgPage++;
        let val = {
          page: this.altasImgPage,
          pageSize: this.altasImgPageSize,
          id: this.altasId
        }
        let {
          status,
          data,
          message,
          errors
        } = await listAtlasPictures(val)
        if (status) {
          // console.log(this.altasSrcList);
          this.altasSrcList = this.altasSrcList.slice(0, this.altasImageListInfo.length)
          // console.log(this.altasSrcList);
          for (let i = 0; i < data.length; i++) {
            errorPic(data[i], data[i].fileInfo.picThumbW640, this.picPrefix)
            this.altasSrcList.push(data[i].src)
            this.altasImageListInfo.push(data[i])
          }
          if (this.altasImgpagination > (this.altasImgPage + 1) * this.altasImgPageSize) {
            for (let j = 0; j < this.altasImgpagination - (this.altasImgPage + 1) * this.altasImgPageSize; j++) {
              this.altasSrcList.push("src")
            }
          }
          // console.log(this.altasSrcList);
        }
      }
      // console.log(this.altasImageListInfo);
      this.altasImageDesc = this.altasImageListInfo[val].desc

    },
    async clickltasPreview (item) {
      this.altasId = item.id
      this.altasLoading = true
      this.altasTitle = item.name
      let val = {
        page: this.altasImgPage,
        pageSize: this.altasImgPageSize,
        id: this.altasId
      }
      let {
        status,
        data,
        message,
        errors,
        pagination
      } = await listAtlasPictures(val)
      if (status) {
        this.altasSrcList = []
        this.altasImageListInfo = []

        this.altasImgpagination = pagination.total
        for (let i = 0; i < data.length; i++) {
          errorPic(data[i], data[i].fileInfo.picThumbW640, this.picPrefix)
          this.altasSrcList.push(data[i].src)
          this.altasImageListInfo.push(data[i])
          if (i == 0) {
            this.altasImageDesc = data[i].desc
          }
        }
        if (this.altasImgpagination > this.altasImgPageSize) {
          for (let j = 0; j < this.altasImgpagination - this.altasImgPageSize; j++) {
            this.altasSrcList.push("src")
          }
        }
        console.log(this.altasSrcList);
      }
      if (this.altasSrcList.length > 0) {
        this.showAltasPreview = true
      } else {
        Notify({
          type: 'warning',
          message: '图集打开失败！'
        })
      }
      this.altasLoading = false
    },
    clickImagePreview (item, index) {
      if (this.showCheckBox) {
        console.log(item, index);
        if (this.imgList[index].checkFalg) {
          this.checkCount--;
        } else {
          this.checkCount++;
        }
        this.imgList[index].checkFalg = !this.imgList[index].checkFalg
        if (this.checkCount != this.imgList.length) {
          this.checkAll = false
        }
        return
      }
      // console.log(item.index);
      this.startImgCountIndex = index
      // console.log(this.imgdesc);
      this.showImagePreview = true
      this.imageDesc = this.imgdesc[index]
      // if (item.index % 2 == 0) {
      //   if (this.imgList[index].desc) {
      //     this.imageDesc = this.imgList[index].desc
      //   } else {
      //     this.imageDesc = ''
      //   }
      // } else {
      //   if (this.imgList1[index].desc) {
      //     this.imageDesc = this.imgList1[index].desc
      //   } else {
      //     this.imageDesc = ''
      //   }
      // }
    },
    outLogin () {
      Dialog.confirm({
        message: '确认退出登录吗？',
      })
        .then(() => {
          // on confirm
          localStorage.removeItem("loginInfo");
          localStorage.removeItem("powers");
          sessionStorage.removeItem("roleCode");
          localStorage.removeItem("createUid");
          localStorage.removeItem("token");
          localStorage.removeItem("firstPage");
          sessionStorage.removeItem("picLove");

          wx.miniProgram.navigateTo({
              url: '/pages/web/web?remove=1'
            })

          setTimeout(() => {
            // location.reload();
            this.$router.push("/login");
          }, 888);
        })
        .catch(() => {
          // on cancel
        });
    },
    choosePicAltasFun (index) {
      this.choosePicAltasIndex = index
      this.finish()
    },
    onSearch () {
      if (this.choosePicAltasIndex == 0) {
        this.imgList = []
        this.imgList1 = []
        this.imgSrcList = []
        if(!this.mineAltasOpen){
          this.statusradio = '1'
        }
        let val = {
          page: 0,
          keyword: this.searchContent,
          createUid: this.contributeName,
          labels: this.labels.join(','),
          pageSize: this.imgPageSize,
          keyword: this.searchContent,
          timeStart: this.startTimeText == "开始时间" ? null : this.startTime,
          timeEnd: this.endTimeText == "结束时间" ? null : this.endTime,
          status: this.statusradio
        }
        this.searchPictureAsync(val)
      } else {
        this.altasList = []
        this.altasList1 = []
        let val = {
          page: 0,
          pageSize: this.altasPageSize,
          keyword: this.searchContent,
          createUid: this.contributeName,
          labels: this.labels.join(','),
          timeStart: this.startTimeText == "开始时间" ? '' : this.startTime,
          timeEnd: this.endTimeText == "结束时间" ? '' : this.endTime,
          status: this.statusradio
        }
        this.searchAtlasAsync(val)
      }
    },
    onCancel () {
      this.searchContent = ''
      this.searchList = []
      this.labels = []
      this.mineAltasOpen = false
      if (this.choosePicAltasIndex == 0) {
        this.imgList = []
        this.imgList1 = []
        this.imgSrcList = []
        this.searchPictureAsync({
          pageSize: this.imgPageSize,
          status: 1
        })
      } else {
        this.altasList = []
        this.altasList1 = []
        this.searchAtlasAsync({
          pageSize: this.altasPageSize,
          status: 1
        })
      }
    },
    finish () {
      // console.log('图库id' + this.chooseLibIndex);
      // console.log('图片主题' + this.choosePicThemeIndex);
      // console.log('环境' + this.chooseEnvironmentIndex);
      // console.log('投稿人' + this.contributeName);
      // console.log('开始时间' + this.startTime);
      // console.log('结束时间' + this.endTime);
      this.showpopup = false
      this.imgPage = 0
      this.altasPage = 0
      this.labels = []

      if (this.choosePicAltasIndex == 0) {
        this.imgdesc = []
        this.imgList = []
        this.imgList1 = []
        this.imgSrcList = []
        this.searchList = []
        if (this.chooseLibIndex != 0) {
          this.searchList.push({
            id: 0,
            name: this.chooseLibName
          })
        }
        if (this.choosePicThemeIndex != 0) {
          this.searchList.push({
            id: 1,
            name: this.choosePicThemeIndex
          })
          this.labels.push(this.choosePicThemeIndex)
        }
        if (this.chooseEnvironmentIndex != 0) {
          this.searchList.push({
            id: 2,
            name: this.chooseEnvironmentIndex
          })
          this.labels.push(this.chooseEnvironmentIndex)
        }

        if(!this.mineAltasOpen){
          this.statusradio = '1'
        }

        let val = {
          createUid: this.mineAltasOpen ? this.createUid : this.contributeName,
          labels: this.labels.join(','),
          libId: this.chooseLibIndex == '0' ? null : this.chooseLibIndex,
          page: this.imgPage,
          pageSize: this.imgPageSize,
          timeStart: this.startTimeText == "开始时间" ? null : this.startTime,
          timeEnd: this.endTimeText == "结束时间" ? null : this.endTime,
          status: this.statusradio,
          peopleName: this.inputValue1
        }
        this.searchPictureAsync(val)
      } else {
        this.altasList = []
        this.altasList1 = []

        let val = {
          createUid: this.mineAltasOpen ? this.createUid : this.contributeName,
          libId: this.chooseLibIndex == '0' ? null : this.chooseLibIndex,
          page: this.altasPage,
          pageSize: this.altasPageSize,
          keyword: this.searchContent,
          timeStart: this.startTimeText == "开始时间" ? '' : this.startTime,
          timeEnd: this.endTimeText == "结束时间" ? '' : this.endTime,
          status: this.statusradio,
          peopleId: this.contributeName1,
        }
        this.searchAtlasAsync(val)
      }
      // this.startTimeText = '开始时间'
      // this.endTimeText = '结束时间'
      // this.contributeName = null
    },
    resetInfo () {
      if (this.libList.length > 0) {
        this.chooseLibIndex = this.libList[0].id
      }
      if (this.picTheme.length > 0) {
        this.choosePicThemeIndex = '0'
      }
      if (this.environmentList.length > 0) {
        this.chooseEnvironmentIndex = 0
      }
      this.mineAltasOpen = false
      this.labels = []
      this.contributeName = null
      this.inputValue = ''
      this.startTimeText = '开始时间'
      this.endTimeText = '结束时间'
      this.searchList = []
    },
    confirmStartTime () {
      console.log(this.storageStartTime);
      let startTime = new Date(this.storageStartTime)
      this.startTime = startTime.getTime() / 1000
      this.startTimeText = formatConversion(this.startTime.toString()).substring(0, 10)
      this.showStartTime = false
    },
    confirmEndTime () {
      console.log(this.storageEndTime);
      let endTime = new Date(this.storageEndTime)
      this.endTime = parseInt(endTime.getTime() / 1000 + 24 * 60 * 60 - 1)
      console.log(this.endTime);
      this.endTimeText = formatConversion(this.endTime.toString()).substring(0, 10)
      console.log(formatConversion(this.endTime.toString()));
      this.showEndTime = false
    },
    chooseEnvironment (item) {
      this.chooseEnvironmentIndex = item.id
    },
    chooseLib (item) {
      this.chooseLibIndex = item.id
      this.chooseLibName = item.name
    },
    choosePicTheme (item) {
      this.choosePicThemeIndex = item.id
    },
    async searchPictureAsync (val) {
      val.keyword=this.searchContent
      this.imgLoading = true
      let {
        status,
        data,
        errors,
        message,
        pagination
      } = await advSearchPicture(val);
      if (status) {
        if(this.imgPage == 0){
          this.imgdesc = []
        }
        for (let i = 0; i < data.length; i++) {
          // data[i].index = this.imgCountIndex++;
          // data[i].index = this.imgList.length + i;
          errorPic(data[i], data[i].picThumbW640, this.picPrefix)
          this.imgSrcList.push(data[i].src)
          // if (i % 2 == 0) {
          data[i].checkFalg = false
          this.imgList.push(data[i])
          // } else {
          //   this.imgList1.push(data[i])
          // }
          
          if (data[i].desc) {
            this.imgdesc.push(data[i].desc)
          } else {
            this.imgdesc.push('')
          }
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        // this.$message.error({ message: message + errortext })
        Notify({
          type: 'danger',
          message: message + errortext
        });
      }
      this.imgPaginationTotal = pagination.total
      // setTimeout(() => {
      this.imgLoading = false
      // }, 800);

    },
    async searchAtlasAsync (val) {
      this.altasLoading = true
      let {
        status,
        data,
        message,
        errors,
        pagination
      } = await searchAtlas(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          errorPic(data[i], data[i].indexpicPath, this.picPrefix)
          data[i].createTime = formatConversion(data[i].createAt.toString()).substring(0, 10)
          if ((i + 1) % 2 == 0) {
            this.altasList1.push(data[i])
          } else {
            // let altasVal = {
            //   page: this.altasImgPage,
            //   pageSize: this.altasImgPageSize,
            //   id: data[i].id
            // }
            // let altasInfo = await listAtlasPictures(altasVal)
            // console.log(altasInfo);
            // for (let k = 0; k < altasInfo.data.length; k++) {
            //   errorPic(altasInfo.data[k], altasInfo.data[k].fileInfo.picThumbW1080, this.picPrefix)
            // }
            // data[i].createAtMY = formatConversion(data[i].createAt.toString())
            // data[i].srcList = altasInfo.data
            this.altasList.push(data[i])
          }
        }
        console.log(this.altasList);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        // this.$message.error({ message: message + errortext })
        Notify({
          type: 'danger',
          message: message + errortext
        });
      }
      this.altasPaginationTotal = pagination.total

      setTimeout(() => {
        this.altasLoading = false
      }, 800);

    },
    async listMyPowerLibAsync () {
      let {
        status,
        data,
        errors
      } = await listMyPowerLib()
      if (status) {
        this.libList = data
      }
      this.libList.unshift({
        name: '全部',
        id: 0
      })
    },
    async myActivityLiveAsync (flag) {
      let {
        status,
        data,
        message,
        pagination
      } = await myActivityLive({
        pageSize: 200,
        keyword: this.inputValue
      });
      if (status) {
        this.contributePeopleList = []
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
              this.contributePeopleList.push({
                value: data[i].id,
                text: data[i].title,
              });
              if (flag && this.inputValue == data[i].name) {
                this.contributeName = data[i].id
              }
          }
        }
      }
    },
    async listUserAsync (flag) {
      let {
        status,
        data,
        message,
        pagination
      } = await listUser({
        pageSize: 200,
        keyword: this.inputValue
      });
      if (status) {
        this.contributePeopleList = []
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
            if (data[i].userType === 0) {
              this.contributePeopleList.push({
                value: data[i].id,
                text: data[i].name,
              });
              if (flag && this.inputValue == data[i].name) {
                this.contributeName = data[i].id
              }
            }
          }
        }
      }
    },
    listUserAsync1 (val) {
      let params = {}
      params.fuzzySearch = true
      params.name = val
      listPeople(params).then(res => {
        console.log(res);
        res.data.forEach(item => {
          item.text = item.peopleName
        })
        this.contributePeopleList1 = res.data
      })
    },
    //获取手机上传url
    async getMobileUpdateUrlAsync () {
      let {
        status,
        data,
        message
      } = await getMobileUpdateUrl();
      if (status) {
        let date = new Date(data.expirationTime);
        date = date.getTime(date);
        // window.location.origin +
        let text =
          data.url +
          "?token=" +
          data.token +
          "&date=" +
          date +
          "&createUid=" +
          this.createUid
        this.$router.push(text)
      }
    },
    //获取应用基础配置
    async getAppBaseConfigAsync () {
      let {
        status,
        data,
        message
      } = await getAppBaseConfig();
      if (status) {
        if (data.logo) {
          this.logosrc = data.logo
        } else {
          if (this.isSimple) {
            this.logosrc = require('@/assets/simple/logo-m.png')
          } else {
            this.logosrc = require('@/assets/login/yunzhiLogo.png')
          }
        }
        console.log(this.logosrc);
      }
    },
    scroll () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      let isBottom = (scrollTop + window.innerHeight) + 10 >= document.body.offsetHeight
      if (isBottom && !this.imgLoading && !this.altasLoading && !this.showpopup) {
        if (this.choosePicAltasIndex == 0 && this.imgPaginationTotal > (this.imgList.length + this.imgList1.length)) {
          this.imgPage++;
          if(!this.mineAltasOpen){
            this.statusradio = '1'
          }
          let val = {
            createUid: this.mineAltasOpen ? this.createUid : this.contributeName,
            labels: this.labels.join(','),
            libId: this.chooseLibIndex == '0' ? null : this.chooseLibIndex,
            page: this.imgPage,
            pageSize: this.imgPageSize,
            keyword: this.searchContent,
            timeStart: this.startTimeText == "开始时间" ? null : this.startTime,
            timeEnd: this.endTimeText == "结束时间" ? null : this.endTime,
            status: this.statusradio
          }
          this.searchPictureAsync(val)
        } else if (this.choosePicAltasIndex == 1 && this.altasPaginationTotal > (this.altasList.length + this
          .altasList1.length)) {
          this.altasPage++;
          let val = {
            createUid: this.mineAltasOpen ? this.createUid : this.contributeName,
            libId: this.chooseLibIndex == '0' ? null : this.chooseLibIndex,
            page: this.altasPage,
            pageSize: this.altasPageSize,
            keyword: this.searchContent,
            timeStart: this.startTimeText == "开始时间" ? null : this.startTime,
            timeEnd: this.endTimeText == "结束时间" ? null : this.endTime,
            status: this.statusradio
          }
          this.searchAtlasAsync(val)
        } else {
          Toast('已展示全部图片！')
        }
      }
    },
    forbidBack () {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    }
  },
  created () {
    window.addEventListener("scroll", this.scroll)
    this.searchPictureAsync({
      status: 1,
      pageSize: 30
    })
    this.searchAtlasAsync({
      pageSize: 20,
      status: 1
    })
    this.listMyPowerLibAsync()
    this.getAppBaseConfigAsync()
  },
  mounted () {
    // 监听手机物理返回键时禁止返回之前的路由
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.forbidBack, false);
      this.forbidBack()
    }
  },
  destroyed () {
    window.removeEventListener("scroll", this.scroll)
    window.removeEventListener('popstate', this.forbidBack, false);
  }
}
</script>
<style lang="scss" scoped>
@import "./pictureCenterMobile.scss";

.contributePeople /deep/ .van-search {
  width: 80%;
}

/deep/ .van-dropdown-menu__bar {
  height: 0;
}

/deep/ .van-search {
  padding: 10px 0px;
}

/deep/ .selbox{
    width: 7.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

// /deep/ .el-input--small .el-input__inner {
//   border-radius: 6.667vw;
// }
// /deep/ .el-select {
//   width: 100%;
// }
/deep/ .van-image-preview__cover {
  position: absolute;
  // bottom: 20px !important;
  top: none;
  top: 77%;
  padding: 5vw;
}

/deep/ .van-image-preview__image{
  pointer-events:none;
}


/deep/ .van-dropdown-item{
  top:105px !important;
}
</style>